export const ServiceNames = [
  "edgify-agent",
  "edgify-non-scan-detector",
  "edgify-on-screen-app",
  "edgify-zebra-adapter",
  "edgify-worker",
] as const;
export type ServiceName = (typeof ServiceNames)[number];
